// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1aS6G","title":"Header_title__2POe9","left":"Header_left__1CuUQ","clinicName":"Header_clinicName__2yMnl"};